export enum TileVariant {
  NORMAL = 'NORMAL',
  BIRTHDAY = 'BIRTHDAY',
  DIVIDEND = 'DIVIDEND',
  IMPACT_FUND = 'IMPACT_FUND',
  REFERRAL = 'REFERRAL',
  SUBPROFILE = 'SUBPROFILE',
}
